/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type address_content_extended = {
    /**
     * Bech32 encoded addresses
     */
    address: string;
    amount: Array<{
/**
 * The unit of the value
 */
unit: string;
/**
 * The quantity of the unit
 */
quantity: string;
/**
 * Number of decimal places of the asset unit. Primary data source is CIP68 reference NFT with a fallback to off-chain metadata.
 */
decimals: number | null;
/**
 * True if the latest minting transaction includes metadata (best-effort)
 */
has_nft_onchain_metadata: boolean;
}>;
    /**
     * Stake address that controls the key
     */
    stake_address: string | null;
    /**
     * Address era
     */
    type: address_content_extended.type;
    /**
     * True if this is a script address
     */
    script: boolean;
};

export namespace address_content_extended {

    /**
     * Address era
     */
    export enum type {
        BYRON = 'byron',
        SHELLEY = 'shelley',
    }


}
